<template>
    <div class="gastouder-hours-submitted">
        <div class="row mb-3 py-2 toolbar-bg">
            <div class="col mb-1 mb-md-0">
                <div class="btn-group btn-group-toggle" role="group">
                    <input
                        class="btn-check"
                        type="radio"
                        name="optionsHour"
                        id="optionsHourPeriod"
                        value="optionsHourPeriod"
                        autocomplete="off"
                        v-model="selectedOption"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="optionsHourPeriod"
                    >Per periode</label>
                    <input
                        class="btn-check"
                        type="radio"
                        name="optionsHour"
                        id="optionsHourChild"
                        value="optionsHourChild"
                        autocomplete="off"
                        v-model="selectedOption"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="optionsHourChild"
                    >Per kind</label>
                </div>
            </div>
        </div>
        <div v-if="selectedOption === 'optionsHourPeriod'">
            <div
                class="accordion mb-1"
                id="accordionHoursPeriod1"
            >
                <div
                    v-bind:key="period"
                    v-for="period in this.childrenPerPeriod"
                    class="accordion-item"
                >
                    <h2 class="accordion-header">
                        <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            :data-bs-target="'#collapseHoursPeriod' + period.period.id"
                            aria-expanded="false"
                            :aria-controls="'collapseHoursPeriod' + period.period.id"
                        >
                            Periode {{ period.period.startDate }} t/m {{ period.period.endDate }}
                            <span class="badge rounded-pill text-bg-secondary ms-auto">{{ period.children.length }}</span>
                        </button>
                    </h2>
                    <div
                        class="accordion-collapse collapse"
                        :id="'collapseHoursPeriod' + period.period.id"
                    >
                        <div class="accordion-body">
                            <div class="list-group list-group-flush">
                                <router-link
                                    class="list-group-item list-group-item-action d-flex justify-content-between align-items-center pe-0 pe-md-3"
                                    v-bind:key="child"
                                    v-for="child in period.children"
                                    :to="'/gastouder/hours-submitted/view/' + period.period.id + '/' + child.id"
                                >
                                    {{ child.name }}
                                    <GastouderStatusBadge :status="child.status"></GastouderStatusBadge>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="this.childrenPerPeriod.length === 0">
                <div class="alert alert-info">
                    Er zijn geen ingediende uren.
                </div>
            </div>
        </div>
        <div v-if="selectedOption === 'optionsHourChild'">
            <div
                class="accordion mb-1"
                id="accordionHoursChild1"
            >
                <div
                    class="accordion-item"
                    v-bind:key="childPeriod"
                    v-for="childPeriod in this.periodsPerChild"
                >
                    <h2 class="accordion-header">
                        <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            :data-bs-target="'#collapseHoursChild' + childPeriod.child.id"
                            aria-expanded="false"
                            :aria-controls="'collapseHoursChild' + childPeriod.child.id"
                        >
                            {{ childPeriod.child.name }}
                            <span class="badge rounded-pill text-bg-secondary ms-auto">{{ childPeriod.periods.length }}</span>
                        </button>
                    </h2>
                    <div
                        class="accordion-collapse collapse"
                        :id="'collapseHoursChild' + childPeriod.child.id"
                    >
                        <div class="accordion-body">
                            <div class="list-group list-group-flush">
                                <router-link
                                    class="list-group-item list-group-item-action d-flex justify-content-between align-items-center pe-0 pe-md-3"
                                    v-bind:key="period"
                                    v-for="period in childPeriod.periods"
                                    :to="'/gastouder/hours-submitted/view/' + period.id + '/' + childPeriod.child.id"
                                >
                                    Periode {{ period.startDate }} t/m {{ period.endDate }}
                                    <GastouderStatusBadge :status="period.status"></GastouderStatusBadge>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="this.periodsPerChild.length === 0">
                    <div class="alert alert-info">
                        Er zijn geen ingediende uren.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GastouderStatusBadge from "@/views/gastouder/components/GastouderStatusBadge.vue";

export default {
    name: 'GastouderHoursSubmitted',
    components: {
        GastouderStatusBadge,
    },
    data() {
        return {
            selectedOption: 'optionsHourPeriod',
            childrenPerPeriod: [],
            periodsPerChild: []
        }
    },
    created() {
        this.getChildrenPerPeriod();
        this.getPeriodsPerChild();
    },
    methods: {
        getChildrenPerPeriod() {
            this.$request.post('/gastouder-time-registration/children-per-period',
                {
                    showSubmitted: true,
                }
            ).then((response) => {
                this.childrenPerPeriod = response
            });
        },
        getPeriodsPerChild() {
            this.$request.post('/gastouder-time-registration/periods-per-child',
                {
                    showSubmitted: true,
                }
            ).then((response) => {
                this.periodsPerChild = response
            });
        }
    }
}

</script>

<style scoped>
.toolbar-bg {
    background-color: rgba(0,0,0,.025);
    border-top: 1px solid rgba(0,0,0,.1);
    border-bottom: 1px solid rgba(0,0,0,.1);
}

.btn-group-toggle label {
    margin: 0;
}
.btn-group-toggle .btn-outline-secondary {
    background-color: #fff;
    border-color: rgba(0,0,0,.2);
    color: rgba(0,0,0,.5);

    &:hover {
        background-color: rgba(0,0,0,.01);
    }
}
.btn-group-toggle .btn-check:checked + .btn {
    color: hsl(206, 90%, 20%);
    background-color: hsl(206, 68%, 90%);
    border-color: hsl(206, 86%, 73%);
    box-shadow: none;
}

.accordion-button {
    --bs-accordion-btn-padding-y: .75rem;
}
.accordion-button:not(.collapsed) {
    color: #082F4D;
    background-color: #f2f9ff;
    box-shadow: none;
}
.accordion-button:has(.badge.rounded-pill)::after {
    margin-left: 1rem;
}
.accordion-body {
    padding: .5rem;
}

</style>